<template>
  <div class="input-common">
    <label v-if="label != ''">{{ label }}</label>
    <input :value="modelValue" @input="emits('update:modelValue', extract_value($event))" :type="type ?? 'text'"
      :placeholder="placeholder" :class="{ uptitle: uptitle, gray: gray, bordered: bordered }" />
    <span v-if="hint" class="hint">{{ hint }}</span>
  </div>
</template>

<script setup lang="ts">
import type { InputTypeHTMLAttribute } from 'vue'

defineProps<{
  label: string
  hint?: string
  type?: InputTypeHTMLAttribute
  modelValue?: string
  placeholder?: string
  uptitle?: boolean
  gray?: boolean
  bordered?: boolean
}>()

function extract_value(e: Event) {
  return (e.target as HTMLInputElement).value
}

const emits = defineEmits<{
  (e: 'update:modelValue', value: string): void
}>()
</script>

<style scoped lang="scss">
@import '@/assets/mixins.scss';

.input-common {
  @include vlayout(10px);

  input {
    padding: 20px;
    background-color: var(--vc-white);
    width: 100%;
    min-width: 700px;
    border-radius: var(--br-small);

    &.gray {
      background-color: var(--vc-gray1);
    }

    &.bordered {
      border: 2px solid var(--vc-gray3);
      border-radius: 5px;
    }
  }

  .hint {
    font-size: 12px;
    color: var(--vc-gray4);
  }
}
</style>
